import { gossipCategories } from "@/mocks/gossipCategories";

export function getCategoryName(slug: string): string {
  const found = gossipCategories.find((category) => category.slug === slug);
  return found ? found.name : "瓜料";
}

export function getCategory(slug: string) {
  return gossipCategories.find((category) => category.slug === slug);
}